module.exports = __webpack_public_path__ + "static/media/regular.e94de3e2.png";